import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { messages } from "./languages";

i18n.use(LanguageDetector).init({
	debug: false,
	defaultNS: ["translations"],
	fallbackLng: "pt",
	ns: ["translations"],
	resources: messages,
	// O React já escapa; sem isto datas/URLs interpoladas saem como "05&#x2F;09&#x2F;2026".
	interpolation: { escapeValue: false },
});

export { i18n };
